import { render, staticRenderFns } from "./guieForVideos.vue?vue&type=template&id=890561f8&scoped=true"
import script from "./guieForVideos.vue?vue&type=script&lang=js"
export * from "./guieForVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890561f8",
  null
  
)

export default component.exports